import { AbstractControl, FormControl } from '@angular/forms';
import { ConstantsService } from '../services/constants.service';
import { NameformatterDirective } from '../directives/nameformatter.directive';
import { CaseTransformationHelper } from '../helpers/case-transformation.helper';

export function ValidateEmail(control: AbstractControl): any {
    const emailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (control.value && !control.value.match(emailRegex)) {
        return { invalidEmail: true };
    }

    return null;
}

export function ValidateState(control: FormControl): { [s: string]: boolean } {
    // if the state is not valid
    if (typeof (control.value) === 'object') {
        if (ConstantsService.getState(control.value)) {
            return null;
        }
    } else {
        return { valid: true };
    }
}

export function ValidateName(control: AbstractControl): { [key: string]: boolean } | null {
    if (control) {
        const inputValue = control.value;
        let outputValue = '';
        let inputValueArray: Array<string>;
        if (inputValue) {
            inputValueArray = inputValue.trim().split(' ');
            let dashSeparatedArray = new Array<string>();
            const prefixArrays: Array<string> = ['jr', 'sr', 'mr', 'ms', 'dr'];
            const specialWOrdArrays: Array<string> = ['no', 'n/a', 'na', 'not applicable', 'none', 'tbd', 'to be determined', 'to be decided', 'don\'t know', 'do not know'];
            const romanRegex = '^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$';
            const capitalLetterRegex = '^[A-Z]*$';
            const lowerLetterRegex = '^[a-z]*$';
            const numericValueRegex = '^[0-9]*$';
            const firstLetterNumeric = '^[0-9][a-zA-Z]*$';
            let isValid = false;
            let validationStatus: any;

            if (inputValue.trim() === '') {
                isValid = true;
                return null;
            }

            inputValueArray.forEach(obj => {
                if (obj.split('').indexOf('-') >= 0) {
                    let dashSeparatedStr = '';
                    dashSeparatedArray = obj.split('-');
                    dashSeparatedArray.forEach(dashObj => dashSeparatedStr = dashSeparatedStr + CaseTransformationHelper.titleCaseFormat(dashObj) + '-');
                    outputValue = dashSeparatedStr.substring(0, dashSeparatedStr.length - 1) + ' ';
                    isValid = (obj === outputValue.trim());
                } else if (!obj.toLowerCase().localeCompare('llc') || !obj.toLowerCase().localeCompare('l.l.c')) {
                    outputValue = obj.toUpperCase() + ' ';
                    isValid = (obj === outputValue.trim());
                } else if (obj.trim().length > 0 && obj.toUpperCase().match(romanRegex)) {
                    outputValue = CaseTransformationHelper.romanNumberFormat(obj) + ' ';
                    isValid = (obj === outputValue.trim());
                } else if (prefixArrays.indexOf(obj.toLowerCase()) >= 0) {
                    outputValue = CaseTransformationHelper.titleCaseFormat(obj) + ' ';
                    isValid = (obj === outputValue.trim());
                } else if (obj.match(firstLetterNumeric)) {
                    outputValue = obj.toLowerCase() + ' ';
                    isValid = (obj === outputValue.trim());
                // tslint:disable-next-line: triple-equals
                } else if (obj.trim().length == 2 && obj.match(capitalLetterRegex)) {
                    outputValue = obj.toUpperCase() + ' ';
                    isValid = (obj === outputValue.trim());
                // tslint:disable-next-line: triple-equals
                } else if (obj.trim().length == 2 && (obj.toLowerCase() != obj || obj.toUpperCase() != obj)) {
                    outputValue = CaseTransformationHelper.titleCaseFormat(obj) + ' ';
                    isValid = (obj === outputValue.trim());
                } else if (obj.match(capitalLetterRegex) || obj.match(lowerLetterRegex)) {
                    outputValue = CaseTransformationHelper.titleCaseFormat(obj) + ' ';
                    isValid = (obj === outputValue.trim());
                // tslint:disable-next-line: triple-equals
                } else if (obj.toLowerCase() != obj || obj.toUpperCase() != obj) {
                    outputValue = obj.trim() + ' ';
                    isValid = (obj === outputValue.trim());
                }
            });
            if (isValid) {
                return null;
            } else {
                validationStatus = { nameFormattingError: true };
                return validationStatus;
            }
        } else {
            return null;
        }
    } else {
        return null;
    }
}
